import every from 'lodash/every'

export default function validateUrls(urls: string[]): boolean {
  const urlRegex = /^https?:\/\/[a-z0-9-]+(\.[a-z0-9-]+)+([\/?].*)?$/ // https://www.oreilly.com/library/view/regular-expressions-cookbook/9781449327453/ch08s01.html

  return every(urls, url => urlRegex.test(url))
}
